import { render, staticRenderFns } from "./items-list.component.vue?vue&type=template&id=64454b13&scoped=true"
import script from "./items-list.component.vue?vue&type=script&lang=ts"
export * from "./items-list.component.vue?vue&type=script&lang=ts"
import style0 from "./items-list.component.vue?vue&type=style&index=0&id=64454b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64454b13",
  null
  
)

export default component.exports